"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamGameAggregateSchema = exports.MultiTeamAggregateSchema = exports.TeamSequenceAggregateSchema = void 0;
const zod_1 = require("zod");
const aggregate_1 = require("./aggregate");
const team_1 = require("./team");
const game_1 = require("./game");
exports.TeamSequenceAggregateSchema = zod_1.z.object({
    game_id: zod_1.z.number(),
    competition_id: zod_1.z.number(),
    season_id: zod_1.z.number(),
    cycle_id: zod_1.z.number(),
    game_date: zod_1.z.string(),
});
exports.MultiTeamAggregateSchema = zod_1.z.object({
    team: team_1.TeamSchema,
    aggregates: aggregate_1.AggregateSchema,
});
exports.TeamGameAggregateSchema = game_1.GameWithRelsSchema.extend({
    aggregates: aggregate_1.AggregateSchema,
});
//# sourceMappingURL=teamAggregate.js.map